import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  icon?: React.ReactNode;
}

export const Input: React.FC<InputProps> = ({ label, error, icon, className = '', ...props }) => {
  return (
    <div className="w-full group">
      <label className="block text-xs font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-2 ml-1 transition-colors group-focus-within:text-blue-600 dark:group-focus-within:text-blue-400">
        {label}
      </label>
      <div className="relative transition-all duration-300 transform group-focus-within:-translate-y-0.5">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-blue-500 transition-colors z-10">
            {icon}
          </div>
        )}
        <input
          className={`
            w-full rounded-2xl bg-gray-50 dark:bg-gray-900/50 
            border-2 border-transparent
            py-4 
            ${icon ? 'pl-12' : 'pl-5'} pr-5
            text-lg font-medium text-gray-900 dark:text-white 
            placeholder-gray-400 dark:placeholder-gray-600
            
            shadow-inner dark:shadow-none
            focus:bg-white dark:focus:bg-gray-900
            focus:border-blue-500/50 dark:focus:border-blue-400/50
            focus:shadow-[0_0_20px_rgba(59,130,246,0.15)]
            focus:ring-0 focus:outline-none
            
            transition-all duration-300
            ${error ? '!border-red-500 focus:shadow-[0_0_20px_rgba(239,68,68,0.15)]' : ''}
            ${className}
          `}
          {...props}
        />
        {/* Glow effect on hover/focus container */}
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-500/0 via-blue-500/0 to-blue-500/0 group-focus-within:from-blue-500/5 group-focus-within:via-purple-500/5 group-focus-within:to-blue-500/5 pointer-events-none -z-10 blur-xl transition-all duration-500" />
      </div>
      {error && (
        <div className="mt-2 ml-1 flex items-center gap-1 text-red-500 animate-in slide-in-from-top-1">
          <span className="w-1 h-1 rounded-full bg-red-500" />
          <p className="text-xs font-bold">{error}</p>
        </div>
      )}
    </div>
  );
};